import React, { useState, useEffect } from "react";

import NotificationCard from "../components/NotificationCard";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { useDbDtata } from "../context/db.context";
import NavBarForCcAndNotification from "../components/NavBarForCcAndNotification";

export const LoadingScreen = ({ open }) => (
  <Backdrop
    sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
    open={open}
  >
    <CircularProgress color="inherit" />
  </Backdrop>
);
export default function Notification() {
  const {getDataByName, loading} = useDbDtata()
  const [notification, setNotification] = useState([]);

  useEffect(()=>{
    const data = getDataByName('notification')
    if(!data) return;
    const tempObj = structuredClone(data);
    const tempArr = Object.values(tempObj).reverse(); 
    setNotification(tempArr)
  },[getDataByName])
  // useEffect(() => {
  //   const fetchData = async () => {
  //     setLoading(true)
  //     onValue(ref(db), (snapshot) => {
  //       const data = snapshot.val();
  //       if (data != null) {
  //         const tempObj = structuredClone(data.notification);
  //         const tempArr = Object.values(tempObj).reverse();
  //         setNotification(tempArr);
  //         setLoading(false)
  //       } else {
  //         console.log("No data ");
  //         setLoading(false)
  //       }
  //     });
  //   };
  //   fetchData();
  // }, []);

  return (
    <div>
      <NavBarForCcAndNotification/>
      <NotificationCard open={loading} notification={notification} />
    </div>
  );
}
